import styled, { css } from 'styled-components';
import { OfferSituation, StatusOffer, TagActiveLabel, TagPaymentLabel, TagStatusLabel,  } from '../../utils';
import { TagDeferralLabel } from '../../utils/enums/TagDeferralLabel';
import { TagBidLabel } from '../../utils/enums/TagStatusCotacao';

interface TagProps {
	$status: StatusOffer | OfferSituation | TagStatusLabel | TagActiveLabel | TagPaymentLabel | TagDeferralLabel | TagBidLabel;
}

export const Container = styled.div<TagProps>`
	width: max-content;
	padding: 4px 8px;
	color: ${({ theme }) => theme.colors.neutral.white};
	border-radius: 8px;
	text-transform: uppercase;
	font-weight: 500;
	letter-spacing: 0.5px;
	font-size: 12px;

	${({ $status }) => {
		switch ($status) {
			case StatusOffer.Soon:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.green};
				`;
			case StatusOffer.Sold:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.red};
				`;
			case OfferSituation.Bought:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightGreen};
					color: ${({ theme }) => theme.colors.neutral.green};
					font-weight: 700;
					text-transform: none;
				`;
			case OfferSituation.Offered:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightRed};
					color: ${({ theme }) => theme.colors.neutral.red};
					font-weight: 700;
					text-transform: none;
				`;
			case TagStatusLabel.Open:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightGreen};
					color: ${({ theme }) => theme.colors.neutral.green};
					font-weight: 700;
					text-transform: none;
				`;
			case TagStatusLabel.Closed:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightRed};
					color: ${({ theme }) => theme.colors.neutral.red};
					font-weight: 700;
					text-transform: none;
				`;
			case TagActiveLabel.Active:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightGreen};
					color: ${({ theme }) => theme.colors.neutral.green};
					font-weight: 700;
					text-transform: none;
				`;
			case TagActiveLabel.Recused:
					return css`
						background-color: ${({ theme }) => theme.colors.neutral.lightRed};
						color: ${({ theme }) => theme.colors.primary.medium};
						font-weight: 700;
						text-transform: none;
				`;
			case TagActiveLabel.Inactive:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightRed};
					color: ${({ theme }) => theme.colors.neutral.red};
					font-weight: 700;
					text-transform: none;
				`;
			case TagPaymentLabel.Paid:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightGreen};
					color: ${({ theme }) => theme.colors.neutral.green};
					font-weight: 700;
					text-transform: none;
				`;
			case TagPaymentLabel.Pending:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightRed};
					color: ${({ theme }) => theme.colors.neutral.red};
					font-weight: 700;
					text-transform: none;
				`;
			case TagPaymentLabel.Renew:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.yellow};
					color: ${({ theme }) => theme.colors.neutral.black};
					font-weight: 700;
					text-transform: none;
				`;
			case TagDeferralLabel.Deferred:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightGreen};
					color: ${({ theme }) => theme.colors.neutral.green};
					font-weight: 700;
					text-transform: none;
				`;
			case TagDeferralLabel.Rejected:
				return css`
					background-color: ${({ theme }) => theme.colors.neutral.lightRed};
					color: ${({ theme }) => theme.colors.neutral.red};
					font-weight: 700;
					text-transform: none;
				`;
			case TagDeferralLabel.Pending:
				return css`
					background-color: rgb(202, 131, 89, 0.15);
					color: ${({ theme }) => theme.colors.primary.medium};
					font-weight: 700;
					text-transform: none;
				`;

				case TagBidLabel.Quoted:
					return css`
						background-color: rgba(113, 167, 242, 0.25); /* verde */
						color: #0063f7;
						font-weight: 700;
						text-transform: none;
					`;

				case TagBidLabel.TopOffer:
					return css`
						background-color: rgba(113, 167, 242, 0.25); /* verde mais suave */
						color: #0063f7;
						font-weight: 700;
						text-transform: none;
					`;

				case TagBidLabel.Outbid:
					return css`
						background-color: rgba(255, 118, 118, 0.15); /* vermelho suave */
						color: #ff3b3b;
						font-weight: 700;
						text-transform: none;
					`;
			default:
				break;
		}
	}}
`;
